import * as React from "react";
import {
  Typography,
  Paper,
  IconButton,
  InputBase,
  Box,
  Container,
  Pagination,
  MenuItem,
  Button,
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Select,
  FormHelperText,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Stack,
  TextField,
} from "@mui/material";
import { connect } from "react-redux";
import { platformTableContainerSx } from "../../app/components/tickitPlatformTheme";
import SearchIcon from "@mui/icons-material/Search";
import {
  centered_flex_box,
  MainInput,
  MainInputLabel,
  main_button,
  sec_button,
  StyledInput,
} from "../../app/components/Styles";
import moment from "moment";
import {
  getWhatsappCampaignInvitations,
  manuallyAcceptCampaignInvitation,
} from "../../app/store/actions/adminActions";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import {
  PlatformEmptyState,
  PlatformLoadingBlock,
} from "../../app/components/platform";

const InvitationRow = ({ invitation, onManualAction, isProcessing }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case "accepted":
        return "success";
      case "rejected":
        return "error";
      case "pending":
        return "warning";
      default:
        return "default";
    }
  };

  const getMessageStatusColor = (status) => {
    switch (status) {
      case "delivered":
        return "success";
      case "read":
        return "info";
      case "sent":
        return "primary";
      case "failed":
        return "error";
      case "deleted":
        return "default";
      default:
        return "default";
    }
  };

  return (
    <TableRow hover>
      <TableCell>
        <Typography variant="body2" fontWeight="medium">
          {invitation.userInfo?.name || "N/A"}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {invitation.userInfo?.phoneNumber || "N/A"}
        </Typography>
      </TableCell>
      <TableCell>
        <Chip
          label={invitation.status}
          color={getStatusColor(invitation.status)}
          size="small"
          sx={{ textTransform: "capitalize" }}
        />
      </TableCell>
      <TableCell>
        <Chip
          label={invitation.messageStatus}
          color={getMessageStatusColor(invitation.messageStatus)}
          size="small"
          sx={{ textTransform: "capitalize" }}
        />
      </TableCell>
      <TableCell>
        {invitation.plusOneMessageStatus ? (
          <Chip
            label={invitation.plusOneMessageStatus}
            color={getMessageStatusColor(invitation.plusOneMessageStatus)}
            size="small"
            sx={{ textTransform: "capitalize" }}
          />
        ) : (
          <Typography variant="body2" color="text.secondary">
            N/A
          </Typography>
        )}
      </TableCell>
      <TableCell>
        {invitation.responseMessageStatus ? (
          <Chip
            label={invitation.responseMessageStatus}
            color={getMessageStatusColor(invitation.responseMessageStatus)}
            size="small"
            sx={{ textTransform: "capitalize" }}
          />
        ) : (
          <Typography variant="body2" color="text.secondary">
            N/A
          </Typography>
        )}
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="text.secondary">
          {invitation.plusOne ? "Yes" : "No"}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="text.secondary">
          {moment(invitation.createdAt).format("MMM DD, YYYY")}
        </Typography>
      </TableCell>
      <TableCell>
        {(invitation.status === "pending" || invitation.status === "accepted") ? (
          <Button
            variant="outlined"
            size="small"
            onClick={() => onManualAction(invitation)}
            disabled={isProcessing}
            sx={{
              borderRadius: 1,
              textTransform: "none",
              minWidth: 160
            }}
          >
            {isProcessing
              ? "Processing..."
              : invitation.status === "accepted"
                ? "Resend Prompt"
                : "Accept Invitation"}
          </Button>
        ) : (
          <Typography variant="body2" color="text.secondary">
            -
          </Typography>
        )}
      </TableCell>
    </TableRow>
  );
};

export const CampaignInvitations = ({
  invitations,
  isLoading,
  getWhatsappCampaignInvitations,
  manuallyAcceptCampaignInvitation
}) => {
  const { id } = useParams();
  const [action, setAction] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [processingInvitationId, setProcessingInvitationId] = React.useState(null);

  const initialState = {
    campaignId: id,
    messageStatus: "any",
    plusOneMessageStatus: "any",
    responseMessageStatus: "any",
    status: "any",
    plusOne: "any",
    search: "",
    page: 1,
    limit: 50,
  };

  React.useEffect(() => {
    // Filter out "any" values before sending to API
    const filteredData = { ...initialState };
    if (filteredData.messageStatus === "any") {
      delete filteredData.messageStatus;
    }
    if (filteredData.plusOneMessageStatus === "any") {
      delete filteredData.plusOneMessageStatus;
    }
    if (filteredData.responseMessageStatus === "any") {
      delete filteredData.responseMessageStatus;
    }
    if (filteredData.status === "any") {
      delete filteredData.status;
    }
    if (filteredData.plusOne === "any") {
      delete filteredData.plusOne;
    } else if (filteredData.plusOne === "true") {
      filteredData.plusOne = true;
    } else if (filteredData.plusOne === "false") {
      filteredData.plusOne = false;
    }
    if (!filteredData.search) {
      delete filteredData.search;
    }
    getWhatsappCampaignInvitations(filteredData);
  }, []);

  const [formData, setFormData] = React.useState(initialState);
  const { messageStatus, plusOneMessageStatus, responseMessageStatus, status, plusOne } = formData;

  const handleClearFilter = (event) => {
    setFormData(initialState);
    setSearchQuery("");
    
    // Filter out "any" values before sending to API
    const filteredData = { ...initialState };
    if (filteredData.messageStatus === "any") {
      delete filteredData.messageStatus;
    }
    if (filteredData.plusOneMessageStatus === "any") {
      delete filteredData.plusOneMessageStatus;
    }
    if (filteredData.responseMessageStatus === "any") {
      delete filteredData.responseMessageStatus;
    }
    if (filteredData.status === "any") {
      delete filteredData.status;
    }
    if (filteredData.plusOne === "any") {
      delete filteredData.plusOne;
    } else if (filteredData.plusOne === "true") {
      filteredData.plusOne = true;
    } else if (filteredData.plusOne === "false") {
      filteredData.plusOne = false;
    }
    if (!filteredData.search) {
      delete filteredData.search;
    }
    getWhatsappCampaignInvitations(filteredData);
  };

  const { page } = formData;

  const handlePageChange = (event, value) => {
    const newFormData = { ...formData, page: value };
    setFormData(newFormData);
    
    // Filter out "any" values before sending to API
    const filteredData = { ...newFormData };
    if (filteredData.messageStatus === "any") {
      delete filteredData.messageStatus;
    }
    if (filteredData.plusOneMessageStatus === "any") {
      delete filteredData.plusOneMessageStatus;
    }
    if (filteredData.responseMessageStatus === "any") {
      delete filteredData.responseMessageStatus;
    }
    if (filteredData.status === "any") {
      delete filteredData.status;
    }
    if (filteredData.plusOne === "any") {
      delete filteredData.plusOne;
    } else if (filteredData.plusOne === "true") {
      filteredData.plusOne = true;
    } else if (filteredData.plusOne === "false") {
      filteredData.plusOne = false;
    }
    if (!filteredData.search) {
      delete filteredData.search;
    }
    getWhatsappCampaignInvitations(filteredData);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setFormData({ ...formData, search: event.target.value });
  };

  const handleSearchFilter = (event) => {
    // Filter out "any" values before sending to API
    const filteredData = { ...formData };
    if (filteredData.messageStatus === "any") {
      delete filteredData.messageStatus;
    }
    if (filteredData.plusOneMessageStatus === "any") {
      delete filteredData.plusOneMessageStatus;
    }
    if (filteredData.responseMessageStatus === "any") {
      delete filteredData.responseMessageStatus;
    }
    if (filteredData.status === "any") {
      delete filteredData.status;
    }
    if (filteredData.plusOne === "any") {
      delete filteredData.plusOne;
    } else if (filteredData.plusOne === "true") {
      filteredData.plusOne = true;
    } else if (filteredData.plusOne === "false") {
      filteredData.plusOne = false;
    }
    if (!filteredData.search) {
      delete filteredData.search;
    }
    getWhatsappCampaignInvitations(filteredData);
  };

  React.useEffect(() => {
    // Filter out "any" values before sending to API
    const filteredData = { ...formData };
    if (filteredData.messageStatus === "any") {
      delete filteredData.messageStatus;
    }
    if (filteredData.plusOneMessageStatus === "any") {
      delete filteredData.plusOneMessageStatus;
    }
    if (filteredData.responseMessageStatus === "any") {
      delete filteredData.responseMessageStatus;
    }
    if (filteredData.status === "any") {
      delete filteredData.status;
    }
    if (filteredData.plusOne === "any") {
      delete filteredData.plusOne;
    } else if (filteredData.plusOne === "true") {
      filteredData.plusOne = true;
    } else if (filteredData.plusOne === "false") {
      filteredData.plusOne = false;
    }
    if (!filteredData.search) {
      delete filteredData.search;
    }
    getWhatsappCampaignInvitations(filteredData);
  }, [action]);

  const handleManualAction = async (invitation) => {
    setProcessingInvitationId(invitation._id);
    try {
      await manuallyAcceptCampaignInvitation({ invitationId: invitation._id });
      setAction((prev) => !prev);
    } finally {
      setProcessingInvitationId(null);
    }
  };

  return (
    <Container component="main" maxWidth="xl">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Paper 
          elevation={0} 
          sx={{ 
            p: 3, 
            mb: 3,
            borderRadius: 2,
            backgroundColor: 'var(--platform-surface)',
            border: '1px solid',
            borderColor: '#e0e0e0'
          }}
        >
          <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4} lg={2.4}>
                <FormControl fullWidth>
                  <InputLabel>Message Status</InputLabel>
                  <Select
                    value={messageStatus}
                    label="Message Status"
                    name="messageStatus"
                    onChange={handleChange}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: { sx: { bgcolor: 'var(--platform-surface)', color: 'var(--primaryPurple)' } },
                      },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'var(--platform-surface)',
                        '& fieldset': {
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'var(--primaryPurple)',
                        },
                        '&:hover fieldset': {
                          borderColor: '#333',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: 'var(--tickit-gray500)',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                        '&.Mui-focused': {
                          color: 'var(--primaryPurple)',
                        }
                      },
                      '& .MuiInputBase-input': {
                        color: 'var(--primaryPurple)',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                      }
                    }}
                  >
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="sent">Sent</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="delivered">Delivered</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="read">Read</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="failed">Failed</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="deleted">Deleted</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="any">Any</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2.4}>
                <FormControl fullWidth>
                  <InputLabel>Plus One Message Status</InputLabel>
                  <Select
                    value={plusOneMessageStatus}
                    label="Plus One Message Status"
                    name="plusOneMessageStatus"
                    onChange={handleChange}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: { sx: { bgcolor: 'var(--platform-surface)', color: 'var(--primaryPurple)' } },
                      },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'var(--platform-surface)',
                        '& fieldset': {
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'var(--primaryPurple)',
                        },
                        '&:hover fieldset': {
                          borderColor: '#333',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: 'var(--tickit-gray500)',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                        '&.Mui-focused': {
                          color: 'var(--primaryPurple)',
                        }
                      },
                      '& .MuiInputBase-input': {
                        color: 'var(--primaryPurple)',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                      }
                    }}
                  >
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="sent">Sent</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="delivered">Delivered</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="read">Read</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="failed">Failed</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="deleted">Deleted</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="any">Any</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2.4}>
                <FormControl fullWidth>
                  <InputLabel>Response Message Status</InputLabel>
                  <Select
                    value={responseMessageStatus}
                    label="Response Message Status"
                    name="responseMessageStatus"
                    onChange={handleChange}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: { sx: { bgcolor: 'var(--platform-surface)', color: 'var(--primaryPurple)' } },
                      },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'var(--platform-surface)',
                        '& fieldset': {
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'var(--primaryPurple)',
                        },
                        '&:hover fieldset': {
                          borderColor: '#333',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: 'var(--tickit-gray500)',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                        '&.Mui-focused': {
                          color: 'var(--primaryPurple)',
                        }
                      },
                      '& .MuiInputBase-input': {
                        color: 'var(--primaryPurple)',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                      }
                    }}
                  >
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="sent">Sent</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="delivered">Delivered</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="read">Read</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="failed">Failed</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="deleted">Deleted</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="any">Any</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2.4}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={status}
                    label="Status"
                    name="status"
                    onChange={handleChange}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: { sx: { bgcolor: 'var(--platform-surface)', color: 'var(--primaryPurple)' } },
                      },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'var(--platform-surface)',
                        '& fieldset': {
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'var(--primaryPurple)',
                        },
                        '&:hover fieldset': {
                          borderColor: '#333',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: 'var(--tickit-gray500)',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                        '&.Mui-focused': {
                          color: 'var(--primaryPurple)',
                        }
                      },
                      '& .MuiInputBase-input': {
                        color: 'var(--primaryPurple)',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                      }
                    }}
                  >
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="pending">Pending</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="accepted">Accepted</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="rejected">Rejected</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="any">Any</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2.4}>
                <FormControl fullWidth>
                  <InputLabel>Plus One</InputLabel>
                  <Select
                    value={plusOne}
                    label="Plus One"
                    name="plusOne"
                    onChange={handleChange}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: { sx: { bgcolor: 'var(--platform-surface)', color: 'var(--primaryPurple)' } },
                      },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'var(--platform-surface)',
                        '& fieldset': {
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'var(--primaryPurple)',
                        },
                        '&:hover fieldset': {
                          borderColor: '#333',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: 'var(--tickit-gray500)',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                        '&.Mui-focused': {
                          color: 'var(--primaryPurple)',
                        }
                      },
                      '& .MuiInputBase-input': {
                        color: 'var(--primaryPurple)',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                      }
                    }}
                  >
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="true">Yes</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="false">No</MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="any">Any</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Search"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ 
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'var(--platform-surface)',
                      '& fieldset': {
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: 'var(--primaryPurple)',
                      },
                      '&:hover fieldset': {
                        borderColor: '#333',
                      },
                    },
                    '& .MuiInputLabel-root': {
                      color: 'var(--tickit-gray500)',
                      fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                      '&.Mui-focused': {
                        color: 'var(--primaryPurple)',
                      }
                    },
                    '& .MuiInputBase-input': {
                      color: 'var(--primaryPurple)',
                      fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} justifyContent="flex-end">
                  <Button
                    variant="outlined"
                    onClick={handleClearFilter}
                    sx={{ 
                      borderRadius: 1,
                      textTransform: 'none',
                      borderColor: 'primary.main',
                      color: 'primary.main',
                      '&:hover': {
                        borderColor: 'primary.dark',
                        backgroundColor: 'rgba(25, 118, 210, 0.04)'
                      }
                    }}
                  >
                    Clear Filters
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleSearchFilter}
                    sx={{ 
                      borderRadius: 1,
                      textTransform: 'none',
                      backgroundColor: 'primary.main',
                      '&:hover': {
                        backgroundColor: 'primary.dark'
                      }
                    }}
                  >
                    Apply Filters
                  </Button>
                </Stack>
              </Grid>
            </Grid>
        </Paper>

        <Paper 
          elevation={0} 
          sx={{ 
            p: 3, 
            borderRadius: 2,
            backgroundColor: 'var(--platform-surface)',
            border: '1px solid',
            borderColor: '#e0e0e0'
          }}
        >
          {!isLoading ? (
            <TableContainer sx={platformTableContainerSx}>
              <Table sx={{ minWidth: 650 }} aria-label="invitations table">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Phone Number</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Message Status</TableCell>
                    <TableCell>Plus One Message</TableCell>
                    <TableCell>Response Message</TableCell>
                    <TableCell>Plus One</TableCell>
                    <TableCell>Created Date</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invitations?.docs?.map((invitation) => (
                    <InvitationRow
                      key={invitation._id}
                      invitation={invitation}
                      onManualAction={handleManualAction}
                      isProcessing={processingInvitationId === invitation._id}
                    />
                  ))}
                </TableBody>
              </Table>
              {invitations?.docs?.length === 0 && (
                <PlatformEmptyState title="No invitations found" description="Try adjusting your filters." />
              )}
            </TableContainer>
          ) : (
            <PlatformLoadingBlock />
          )}
          <Box sx={{ ...centered_flex_box, mt: 3 }}>
            <Pagination
              count={invitations?.pages || 1}
              page={page}
              onChange={handlePageChange}
              color="primary"
              sx={{
                '& .MuiPaginationItem-root': {
                  borderRadius: 1
                }
              }}
            />
          </Box>
        </Paper>
      </motion.div>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  invitations: state?.records?.results?.invitations,
  isLoading: state?.records?.isLoading,
});

const mapDispatchToProps = { getWhatsappCampaignInvitations, manuallyAcceptCampaignInvitation };

export default connect(mapStateToProps, mapDispatchToProps)(CampaignInvitations);
